
import React from 'react';
import { MemorabilityBreakdown as MemorabilityBreakdownType } from '@/utils/memorabilityCalculator';
import { Progress } from '@/components/ui/progress';

interface MemorabilityBreakdownProps {
  breakdown: MemorabilityBreakdownType;
}

const MemorabilityBreakdown: React.FC<MemorabilityBreakdownProps> = ({ breakdown }) => {
  const categories = [
    { 
      name: 'Sound Tricks', 
      value: breakdown.sound_tricks, 
      max: 10,
      color: 'bg-blue-500',
      emoji: '🔊',
      description: 'How the phrase sounds when spoken aloud'
    },
    { 
      name: 'Emotion & Imagery', 
      value: breakdown.emotion_imagery, 
      max: 10,
      color: 'bg-purple-500',
      emoji: '💭',
      description: 'Emotional resonance and visual associations'
    },
    { 
      name: 'Cognitive Grip', 
      value: breakdown.cognitive_grip, 
      max: 10,
      color: 'bg-green-500',
      emoji: '🌀',
      description: 'How easily the brain can grasp and retain the phrase'
    }
  ];

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Score Breakdown</h3>
      
      <div className="space-y-6">
        {categories.map((category) => (
          <div key={category.name} className="space-y-1">
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-1.5">
                <span>{category.emoji}</span>
                <span className="font-medium">{category.name}</span>
              </div>
              <div className="text-sm font-semibold">
                {category.value}/{category.max}
              </div>
            </div>
            
            <Progress 
              value={(category.value / category.max) * 100} 
              className="h-2"
            />
            
            <p className="text-xs text-gray-500 mt-1">{category.description}</p>
          </div>
        ))}
      </div>
      
      <div className="pt-2 flex justify-between items-center border-t">
        <span className="font-semibold">Overall Score:</span>
        <span className="font-bold text-lg">{breakdown.total}/30</span>
      </div>
    </div>
  );
};

export default MemorabilityBreakdown;
